import script from "./MobileMenuFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileMenuFooter.vue?vue&type=script&setup=true&lang=js"

import "./MobileMenuFooter.vue?vue&type=style&index=0&id=af4e035e&lang=scss"

const __exports__ = script;

export default __exports__